import { render, staticRenderFns } from "./BillsList.vue?vue&type=template&id=2660e902&"
import script from "./BillsList.vue?vue&type=script&lang=js&"
export * from "./BillsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports